import { Service } from '../Service'

const API = 'ReplacementParts'

const ENDPOINTS = {
  GET: `${API}/Get`,
  GET_DYNAMIC: `${API}/GetAllDynamic`,
  POST: `${API}/Create`,
  PATCH: `${API}/Patch`,
  PUT: `${API}/Put`,
  DELETE: `${API}/Delete`
}

class ModuleService extends Service {
}

export const ServiceReplacementParts = new ModuleService({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})
